<template>
  <div>
    <v-list dense nav>

      <v-list-item to="/"
        color="#244EA2"
      >
        <v-list-item-icon>
          <v-icon>mdi-layers</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Camadas</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider />

    <v-list dense nav subheader>
      <v-subheader>PESQUISAS</v-subheader>

      <v-list-item v-for="(item, i) in pesquisa" :key="i" :to="item.route"
        color="#244EA2"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list dense nav subheader>
      <v-subheader>SISPROFICE</v-subheader>

      <v-list-item
        v-for="(item, i) in sisprofice"
        :key="i"
        :to="item.route"
        color="#244EA2"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list dense nav subheader>
      <v-subheader>GESTÃO MUNICIPAL</v-subheader>

      <v-list-item
        v-for="(item, i) in gestao"
        :key="i"
        :to="item.route"
        color="#244EA2"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'Navegacao',
  data: () => ({
    pesquisa: [
      {
        title: 'Agentes',
        icon: 'mdi-account',
        route: '/pesquisa/agente'
      },
      {
        title: 'Equipamentos',
        icon: 'mdi-theater',
        route: '/equipamentos'
      },
      {
        title: 'Meios de Comunicação',
        icon: 'mdi-radio-tower',
        route: '/meio_comunicacao'
      },
      {
        title: 'Atividades',
        icon: 'mdi-drama-masks',
        route: '/atividade'
      },
      {
        title: 'Patrimônio Cultural',
        icon: 'mdi-city-variant-outline',
        route: '/patrimonios'
      }
    ],
    gestao: [
      //{ title: 'Secretarias Municipais', icon: 'mdi-home', route: '/orgao' },
      { title: 'Perfil Gestor', icon: 'mdi-account', route: '/orgao' },
      { title: 'Conselho Municipal', icon: 'mdi-account-group', route: '/conselhomunicipal' },
      { title: 'Instrumento de Gestão', icon: 'mdi-account-details', route: '/instrumentogestao' },
      { title: 'Legislação', icon: 'mdi-scale-balance', route: '/legislacao' },
      { title: 'Recursos Financeiros', icon: 'mdi-finance', route: '/recursofinanceiro' }
    ],
    sisprofice: [
      {
        title: 'Projetos',
        icon: 'mdi-presentation',
        route: '/projeto_apresentado'
      },
      /*{
        title: 'Projetos Selecionados',
        icon: 'mdi-presentation',
        route: '/projeto_selecionado'
      },
      {
        title: 'Projetos Contemplados',
        icon: 'mdi-presentation',
        route: '/projeto_contemplado'
      },*/
      {
        title: 'Locais de Realização',
        icon: 'mdi-map-marker',
        route: '/local_realizacao'
      },
      {
        title: 'Orçamentos de Projetos',
        icon: 'mdi-cash-marker',
        route: '/orcamento_projeto_solicitado'
      },
      /*{
        title: 'Orçamentos de Projetos Contemplados',
        icon: 'mdi-cash-marker',
        route: '/orcamento_projeto_contemplado'
      }*/
    ]
  })
}
</script>
